// Alert Modal Component - Matches ConfirmationModal design
import React, { useEffect } from 'react';
import './AlertModal.css';

const AlertModal = ({
    isOpen,
    onClose,
    title = 'Alert',
    message = '',
    type = 'info', // 'error', 'warning', 'info', 'success'
    buttonText = 'OK'
}) => {
    // Handle escape key press
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape' && isOpen) {
                onClose();
            }
        };

        if (isOpen) {
            document.addEventListener('keydown', handleEscape);
            // Prevent scrolling when modal is open
            document.body.style.overflow = 'hidden';
        }

        return () => {
            document.removeEventListener('keydown', handleEscape);
            document.body.style.overflow = 'unset';
        };
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    // Get icon based on type
    const getIcon = () => {
        switch (type) {
            case 'error':
                return '❌';
            case 'warning':
                return '⚠️';
            case 'success':
                return '✅';
            case 'info':
            default:
                return 'ℹ️';
        }
    };

    return (
        <div className="alert-modal-overlay" onClick={onClose}>
            <div className={`alert-modal alert-modal-${type}`} onClick={(e) => e.stopPropagation()}>
                <div className="alert-modal-header">
                    <span className="alert-modal-icon">{getIcon()}</span>
                    <h2 className="alert-modal-title">{title}</h2>
                </div>
                <div className="alert-modal-body">
                    <p className="alert-modal-message">{message}</p>
                </div>
                <div className="alert-modal-footer">
                    <button
                        className={`alert-modal-btn alert-btn-${type}`}
                        onClick={onClose}
                        autoFocus
                    >
                        {buttonText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AlertModal;
